import FontIcon from './FontIcon';
export default FontIcon;

import _FontIcon from './FontIcon';
export { _FontIcon as FontIcon };


//////////////////
// WEBPACK FOOTER
// ../es/FontIcons/index.js
// module id = JSfR
// module chunks = 73